import { render } from "./CellDataTableComponent.vue?vue&type=template&id=ca576596"
import script from "./CellDataTableComponent.vue?vue&type=script&lang=js"
export * from "./CellDataTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__